import { connect } from 'react-redux';
import TaskRow from './TaskRow';
import { sortTasksRequest, updateTaskFlag } from '../../../../../store/actions/scope.actions';
const mapDispatchToProps = { 
    sortTasksRequest,
    updateFlag: updateTaskFlag
};
const mapStateToProps = (state) => { 
   
    return { };
 };

export default connect(mapStateToProps, mapDispatchToProps)(TaskRow);
